const t = "magnet", e = {
  magnet: t
};
export {
  e as default,
  t as magnet
};
